import InfoPersoStep7FormComponent from '../../components/info-perso/InfoPersoStep7FormComponent';


export default function InfoPersoStep7Bloc() {

      return (
        <div className="">
        <div className="">
          <p className='text fw-normal mb-md'></p>
          <InfoPersoStep7FormComponent />  
        </div>
      </div>
      )
}